import React, { useContext } from 'react';
import useSeasonalEvent from '../SeasonalEvents.js';
import { LanguageContext } from '../../context/LanguageContext.js';

function PrideHeader() {
  const { language, translations } = useContext(LanguageContext);
  const isPrideMonth = useSeasonalEvent({ month: 5 });

  return (
    <div>
      {isPrideMonth && (
        <h1 className="pride-h">
          {translations[language].pages.home.h2}{' '}
          <img
            className="pride"
            src="https://pufok.gay/PublicResources/pride.png"
            alt="pride"
          />
        </h1>
      )}
    </div>
  );
}

export default PrideHeader;
